import {observable, action} from 'mobx';
import axiosInstance from '~/utils/axiosInstance';
import uris from '~/uris';

class OuStore {
  @observable initLan = [];

  @observable selectedLan = [];

  @observable selectedLanInCode = [];

  @action.bound
  setSelectedLan(arr) {
    this.selectedLan = arr;
  }

  @action.bound
  setInitLan(arr) {
    this.initLan = arr;
  }

  @action.bound
  setSelectedLanInCode(arr) {
    this.selectedLanInCode = arr;
  }

  @action.bound
  modifyOrganizationLan(languages) {
    return axiosInstance.post(uris.modifyOrganizationLan(), {
      languages
    });
  }
}

export default new OuStore();
